import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { Avatar } from './Avatar';
import { AvatarName } from './AvatarName';
import { Preloader0, Preloader } from './kit';
import './MobMenu.css';


const Loader = () => {
  return (
    <div
    className="x_mob_menu_item"
    style={{
      position: 'relative',
    }}
  >
      <Preloader0
      style={{ 
        position: 'absolute', 
        zIndex: 10, 
        top: 0, 
        filter: 'invert(1)',
        left: 0, 
        width: '100%', 
        height: '100%', 
        opacity: 0.3,
      }}
      >
        <Preloader width={44} height={44} />
      </Preloader0>
    </div>
  )
}

export function MobMenu({ 
  avatar = {}, 
  penta = {},
  hidden = false,
  showItems = [
    'world',
    'people',
    'history',
    'bodygraphs',
    'pentas',
  ]
}) {
  const navigate = useNavigate();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  const $ui = context.$ui;

  const [active, setActive] = useState(context.state.peoplePanel ? context.state.peoplePanel : []);
  useEffect(() => {
    if (context.state.peoplePanel && context.state.peoplePanel[0] !== active[0]) {
      setActive(context.state.peoplePanel)
    }
    if (!context.state.peoplePanel && active.length) {
      setActive([])
    }
  }, [context])


  const memberLetter = (member) => {
    const name = member?.avatar?.name?.trim();
    if (name) return name.slice(0, 1);
    const fromType = (context.getDefaultTitle(member?.avatar?.design, 'type') || '')
      .replace(/^[\s\u00A0\u2009]+/, '')
      .split(/[\s\u00A0\u2009]/)[0];
    return fromType || '';
  };

  const pentaName = (penta) => {
    if (penta?.name) return penta.name;
    const members = penta?.members || [];
    if (!members.length) return '';
    const letter1 = memberLetter(members[0]);
    const letter2 = members[1] ? memberLetter(members[1]) : '';
    return letter2 ? `${letter1} + ${letter2}` : letter1;
  };

  const hasPenta = Boolean(penta?.token) || Boolean(penta?.members?.length);

  const pentaAvatars = (
    <div className={`x_mob_menu_avas ${penta?.members?.length === 3 ? 'x_mob_menu_avas--3' : ''} ${penta?.members?.length > 3 ? 'x_mob_menu_avas--large' : ''}`}>
      {(penta?.members || []).slice(0, 3).map((one, index) => (
        <div
          className="x_mob_menu_ava"
          key={one.avatar?.token || index}
          style={{ zIndex: (penta.members.length - index) }}
        >
          <Avatar
            tooltip={false}
            style={{ fontSize: '0.7em' }}
            avatar={one.avatar}
          />
        </div>
      ))}
    </div>
  );



  // HASH
  const location = useLocation();
  useEffect(() => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1)); // Remove the leading '#'
    const panel = params.get('p');
  }, [location]);



  const closePanel = (newPanel) => {
    const hash = location.hash;
    const params = new URLSearchParams(hash.slice(1)); // Remove the leading '#'
    params.delete('p');
    const newHash = params.toString();
    window.history.replaceState(null, '', `${location.pathname}${location.search}${newHash ? `#${newHash}` : ''}`);
    context.setState.showPeoplePanel()
  };


  const setPeoplePanel = (newPanel, group) => {
    const hash = location.hash.substring(1); // Remove the leading '#'
    const params = new URLSearchParams(hash);
    if (newPanel) {
      params.set('p', newPanel); // Set the new panel parameter
      context.setState.showPeoplePanel(newPanel);
    } else {
      params.delete('p');
      context.setState.showPeoplePanel();
    }
    if (group) { params.set('g', group); }
    const newHash = params.toString();
    navigate(`${location.pathname}${location.search}${newHash ? `#${newHash}` : ''}`);
  };





  const [isScrolledDown, setIsScrolledDown] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const menu = menuRef.current;
    if (!menu) return;

    const syncMenuBarHeight = () => {
      if (menu.classList.contains('x_mob_menu0--hidden')) {
        document.documentElement.style.removeProperty('--mob-menu-bar-height');
        return;
      }
      const panel = menu.querySelector('.x_mob_menu_panel');
      if (!panel) return;
      const offset = Math.max(0, window.innerHeight - panel.getBoundingClientRect().top);
      document.documentElement.style.setProperty('--mob-menu-bar-height', `${offset}px`);
    };

    syncMenuBarHeight();
    const ro = new ResizeObserver(syncMenuBarHeight);
    ro.observe(menu);
    const panel = menu.querySelector('.x_mob_menu_panel');
    if (panel) ro.observe(panel);

    window.addEventListener('resize', syncMenuBarHeight);
    window.addEventListener('scroll', syncMenuBarHeight, true);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', syncMenuBarHeight);
      window.removeEventListener('scroll', syncMenuBarHeight, true);
      document.documentElement.style.removeProperty('--mob-menu-bar-height');
    };
  }, [hidden, isScrolledDown, context.state.calcShown, context.state.pentaChooseId, context.state.groupChooseId]);

  useEffect(() => {
    const handleScroll = (e) => {
      let scrollTop, viewportHeight, contentHeight;

      const target = e && e.target;
      if (target && target !== document && target.nodeType === 1) {
        // Inner scroll container (e.g. .yoni_result0 on /yoni pages, where the
        // window itself never scrolls). Ignore small scrollareas (dropdowns,
        // inline lists) — only react to page-sized scrollers.
        if (target.clientHeight < window.innerHeight * 0.5) return;
        scrollTop = target.scrollTop;
        viewportHeight = target.clientHeight;
        contentHeight = target.scrollHeight;
      } else {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        viewportHeight = window.innerHeight;
        contentHeight = document.documentElement.scrollHeight;
      }

      if (scrollTop > 120) {
        setIsScrolledDown(scrollTop > lastScrollTop);
        setLastScrollTop(scrollTop);
      }

      if (scrollTop + viewportHeight >= contentHeight - 10) {
        setIsAtBottom(true);
        setIsScrolledDown()
      } else {
        setIsAtBottom(false);
      }
    };

    // Scroll events don't bubble, so use the capture phase to also catch
    // scrolls happening inside nested scroll containers.
    window.addEventListener('scroll', handleScroll, true);

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [lastScrollTop]);



  const goTO = (to) => {
    setPeoplePanel(to)
    context.setState.setCalcShown(false);
  }

  const worldCityTitle = context.myCity?.city;

  // console.log('context.state.citySearchActive = ', context.state.citySearchActive);

  return (
    <>
      <div ref={menuRef} className={`${hidden || context.state.pentaChooseId || context.state.groupChooseId ? 'x_mob_menu0--hidden ' : ''}${isScrolledDown ? 'x_mob_menu0 scrolled' : `x_mob_menu0 ${context.state.citySearchActive ? 'scrolled' : ''}`}`}
        style={{
          marginBottom: context.state.calcShown ? '-8em' : '0'
        }}
      >
        <div className="x_mob_menu_panel">
          <div className="x_mob_menu_sub0">

            {/* {showItems.includes('world') && !Boolean(context.geoPeople) && <Loader />} */}

            {showItems.includes('world') 
            // && Boolean(context.geoPeople) 
            && <div
              className={active.includes('world') ? "x_mob_menu_item active" : "x_mob_menu_item"}
              onClick={() => goTO(['world'])}
            >
              <div className="x_mob_menu_icon">
                <div className="t_icon">
                  <div>travel_explore</div>
                </div>
              </div>
              <div className="x_mob_menu_text x_mob_menu_text--city">{worldCityTitle || $ui('people_city')}</div>
            </div>}

            {showItems.includes('people') && !context.followingsHydrated && <Loader />}

            {showItems.includes('people') && context.followingsHydrated && <div
              className={active.includes('people') ? "x_mob_menu_item active" : "x_mob_menu_item"}
              onClick={() => goTO(['people', 'followers'])}
            >
              <div className="x_mob_menu_icon">
                <div className="t_icon">
                  <div>group</div>
                </div>
              </div>
              <div className="x_mob_menu_text">{$ui('people_people')}</div>
            </div>}


            {/* {context.state.peoplePanel && <div
              className={active.includes('history') ? "x_mob_menu_item active" : "x_mob_menu_item"}

              onClick={() => context.setState.showPeoplePanel(false)}
            >
              <div className="x_mob_menu_icon">
                <div className="t_icon">
                  <div>history</div>
                </div>
              </div>
              <div className="x_mob_menu_text">Recents</div>
            </div>} */}




            {showItems.includes('history') && Boolean(avatar.token) && context.state.peoplePanel && <div
              // className={active.includes('history') ? "x_mob_menu_item active" : "x_mob_menu_item"}
              className={"x_mob_menu_item"}
              onClick={() => goTO()}
            >
              <div className="x_mob_menu_ava0">
                <div className="x_mob_menu_ava">
                  <Avatar
                    style={{
                      fontSize: '0.8em'
                    }}
                    avatar={avatar} />
                </div>
              </div>
              <div className="x_mob_menu_text">
                {/* {avatar.name ? avatar.name : context.getDefaultTitle(avatar.design, 'type', context.language)} */}
                <AvatarName avatar={avatar} />
              </div>
            </div>}

            {showItems.includes('history') && !(Boolean(avatar.token) || hasPenta) && !context.state.peoplePanel && <Loader />}

            {showItems.includes('history') && Boolean(avatar.token) && !context.state.peoplePanel && <div
              className={!context.state.peoplePanel ? "x_mob_menu_item active" : "x_mob_menu_item"}
              onClick={() => goTO(['history'])}
            >
              <div className="x_mob_menu_ava0">
                <div className="x_mob_menu_ava">
                  <Avatar
                    active={true}
                    style={{
                      fontSize: '0.8em'
                    }}
                    avatar={avatar} />
                </div>
              </div>
              <div className="x_mob_menu_text">{avatar.name ? avatar.name : context.getDefaultTitle(avatar.design, 'type')}</div>
            </div>}


            {!Boolean(avatar.token) && hasPenta && !context.state.peoplePanel && <div
              className={!context.state.peoplePanel ? "x_mob_menu_item active" : "x_mob_menu_item"}
              onClick={() => goTO(['history'])}
            >
              <div className="x_mob_menu_ava0">
                {pentaAvatars}
              </div>
              <div className="x_mob_menu_text">{pentaName(penta)}</div>
            </div>}

            {!Boolean(avatar.token) && hasPenta && context.state.peoplePanel && <div
              className={!context.state.peoplePanel ? "x_mob_menu_item active" : "x_mob_menu_item"}
              onClick={() => goTO()}
            >
              <div className="x_mob_menu_ava0">
                {pentaAvatars}
              </div>
              <div className="x_mob_menu_text">{pentaName(penta)}</div>
            </div>}


            {showItems.includes('bodygraphs') && !Boolean(context.avatars) && !context.state.peoplePanel && <Loader />}

            {showItems.includes('bodygraphs') && Boolean(context.avatars) && <div
              className={active.includes('bodygraphs') ? "x_mob_menu_item active" : "x_mob_menu_item"}
              onClick={() => goTO(['bodygraphs'])}
            >
              <div className="x_mob_menu_icon">
                <div className="t_icon">
                  <div>person_search</div>
                </div>
              </div>
              <div className="x_mob_menu_text">{$ui('people_bodygraphs')}</div>
            </div>}


            {showItems.includes('pentas') && !Boolean(context.pentas) && <Loader />}

            {showItems.includes('pentas') && Boolean(context.pentas) && <div
              className={active.includes('pentas') ? "x_mob_menu_item active" : "x_mob_menu_item"}
              onClick={() => {
                goTO(['pentas']);
                // if (active.includes('pentas')) context.setState.setPentaFolders(!context.state.pentaFolders);
              }}
            >
              <div className="x_mob_menu_icon">
                <div className="t_icon">
                  <div>diversity_3</div>
                </div>
              </div>
              <div className="x_mob_menu_text">{$ui('people_synergy')}</div>
            </div>}

          </div>
        </div>
      </div>


    </>
  )
}
